module.exports = __webpack_public_path__ + "img/laptop.74c2b445.png";